export default "__VITE_ASSET__DtL7mneY__"